import React from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import FurnitureRental from './FurnitureRental'

function RentalFurnituresIndex() {
  return (
    <div>
      <Navbar />
        <FurnitureRental />
      <Footer />
    </div>
  )
}

export default RentalFurnituresIndex
